// extracted by mini-css-extract-plugin
module.exports = {"buttonholder":"Record_buttonholder__3BqLV","addbutton":"Record_addbutton__2_oRd"};